import { baseVariables } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const Wrapper = styled.section`
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  .o-chat-signed-out-container {
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 2rem;
    max-width: 21.25rem;
    .o-chat-signed-out-icon {
      margin-bottom: 1.5rem;
    }
    .o-chat-signed-out-text-block {
      margin-bottom: 1.5rem;
      h1 {
        span {
          color: ${baseVariables.color['alert40']};
        }
      }
      p {
        color: ${baseVariables.color['neutral40']};
      }
    }
    .o-chat-signed-out-remembered-footer {
      flex-wrap: wrap;
      gap: 0 0.75rem;
      text-align: center;
    }
    .o-chat-signed-out-remembered-label {
      font-size: 0.875rem;
      line-height: 1.25rem;
      color: var(--t-brand-fg-color);
    }
    .rememberedBtn {
      justify-content: center;
    }
    .o-chat-signed-out-remembered-join.m-link-tertiary-button {
      display: inline-flex;
      justify-content: center;
      color: var(--t-brand-fg-color);
      line-height: 1.25rem;
      gap: 0 4px;
      .btn-label {
        color: var(--t-brand-fg-color);
      }
      &:not(.disabled) .icon {
        color: var(--t-brand-fg-color);
      }
      &:not(.disabled):hover,
      &:not(.disabled):focus {
        .icon {
          color: var(--t-brand-fg-color);
        }
      }
    }
  }
`;

export const SignInButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  button[data-testid='common-static-SignInDrawer'] {
    margin-bottom: 1.5rem;
    padding: 0.5rem 1rem !important;
    border: 0.0625rem solid;
    border-radius: 1.25rem;
    background-color: black !important;
    color: white !important;
    min-width: 6.25rem;
  }
`;
